export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/brand_voice_tone.ffef839.svg";